(function(){"use strict";(i=>{try{if(typeof window>"u")return;var e=document.createElement("style");e.appendChild(document.createTextNode(i)),document.head.appendChild(e)}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})(".voice-visualizer__buttons-container{display:flex;justify-content:center;align-items:center;column-gap:20px;row-gap:15px;flex-wrap:wrap;margin-bottom:40px}.voice-visualizer__btn-center{box-sizing:border-box;flex-shrink:0;width:60px;height:60px;padding:0;display:flex;justify-content:center;align-items:center;border-radius:50%;background-color:#fff;border:4px solid #c5c5c5;outline:none;cursor:pointer;transition:border-color .3s,background-color .3s}.voice-visualizer__btn-center:disabled{opacity:.85;cursor:default}.voice-visualizer__btn-center:hover{background-color:#eaeaea;border:4px solid #9f9f9f}.voice-visualizer__btn-center>img{width:auto;height:50%;max-height:30px}.voice-visualizer__btn-center.voice-visualizer__btn-center-pause{background-color:#ff3030}.voice-visualizer__btn-center.voice-visualizer__btn-center-pause:hover{background-color:#ff4f4f}.voice-visualizer__btn-center.voice-visualizer__btn-center-pause>img{height:50%;max-height:16px}.voice-visualizer__btn-center.voice-visualizer__btn-center--border-transparent{border-color:transparent}.voice-visualizer__btn-center.voice-visualizer__btn-center--border-transparent:hover{background-color:#fff}.voice-visualizer__btn-left{box-sizing:border-box;flex-shrink:0;width:60px;height:60px;padding:0;display:flex;justify-content:center;align-items:center;border-radius:50%;background-color:#ff3030;border:4px solid #c5c5c5;outline:none;cursor:pointer;transition:border-color .3s,background-color .3s,opacity .3s}.voice-visualizer__btn-container{min-width:100px;display:flex;justify-content:flex-end}.voice-visualizer__btn-left:hover{background-color:#ff4f4f}.voice-visualizer__btn-left:disabled{opacity:.6;background-color:#ff3030;cursor:default}.voice-visualizer__btn-left.voice-visualizer__btn-left-microphone{background-color:#fff}.voice-visualizer__btn-left.voice-visualizer__btn-left-microphone>img{width:auto;height:50%;max-height:30px}.voice-visualizer__btn-left>img{width:auto;height:50%;max-height:16px}.voice-visualizer__btn-left:hover{border:4px solid #9f9f9f}.voice-visualizer__btn{box-sizing:border-box;min-width:100px;min-height:60px;padding:5px 20px;border-radius:40px;font-size:15px;background-color:#f0f0f0;transition:background-color .3s,opacity .3s}.voice-visualizer__btn:disabled{opacity:.8;background-color:#f0f0f0;cursor:default}.voice-visualizer__btn:hover{background-color:#bebebe}.voice-visualizer__canvas-container{position:relative;width:fit-content;margin:0 auto;overflow:hidden}.voice-visualizer__canvas-container canvas{display:block}.voice-visualizer__canvas-microphone-btn{position:absolute;top:50%;left:50%;width:auto;max-width:12%;min-width:24px;height:50%;max-height:100px;background-color:transparent;border:none;outline:none;transform:translate(-50%,-50%)}.voice-visualizer__canvas-microphone-icon{width:100%;height:100%;will-change:transform;transition:transform .3s}.voice-visualizer__canvas-microphone-btn:hover .voice-visualizer__canvas-microphone-icon{transform:scale(1.03)}.voice-visualizer__canvas-audio-wave-icon{position:absolute;top:50%;left:50%;width:auto;max-width:40%;height:40%;max-height:100px;transform:translate(-118%,-50%) scale(-1)}.voice-visualizer__canvas-audio-wave-icon2{transform:translate(18%,-50%)}.voice-visualizer__canvas-audio-processing{position:absolute;top:50%;left:50%;margin:0;transform:translate(-50%,-50%)}.voice-visualizer__progress-indicator-hovered{position:absolute;top:0;pointer-events:none;height:100%;width:1px;background-color:#85858599}.voice-visualizer__progress-indicator-hovered-time{position:absolute;top:3%;left:1px;width:fit-content;margin:0;padding:0 7px;opacity:.8;font-size:12px;border-radius:0 4px 4px 0;background-color:#575757;text-align:left}.voice-visualizer__progress-indicator-hovered-time.voice-visualizer__progress-indicator-hovered-time-left{left:unset;right:1px;border-radius:4px 0 0 4px}.voice-visualizer__progress-indicator{position:absolute;top:0;pointer-events:none;height:100%;width:1px;background-color:#efefef}.voice-visualizer__progress-indicator-time{position:absolute;top:3%;left:1px;width:fit-content;box-sizing:border-box;min-width:37px;margin:0;padding:0 7px;font-size:12px;border-radius:0 4px 4px 0;text-align:left;color:#000;font-weight:500;background-color:#efefef}.voice-visualizer__progress-indicator-time.voice-visualizer__progress-indicator-time-left{left:unset;right:1px;border-radius:4px 0 0 4px}.voice-visualizer__audio-info-container{box-sizing:border-box;height:55px;display:flex;align-items:center;justify-content:center;gap:30px}.voice-visualizer__audio-info-time{margin:15px 0;min-width:38px;text-align:left}.voice-visualizer__visually-hidden{position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:4px solid #c5c5c5;white-space:nowrap;clip-path:inset(100%);clip:rect(0 0 0 0);overflow:hidden}.relative{position:relative}.spinner__wrapper{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:52px;height:52px;display:flex;justify-content:center;align-items:center}.spinner{flex-shrink:0;width:100%;height:100%;border:4px solid rgba(197,197,197,.5);border-radius:50%;border-top-color:#b7b7b7;animation:spin 1s ease-in-out infinite;-webkit-animation:spin 1s ease-in-out infinite}@keyframes spin{to{transform:rotate(360deg)}}@-webkit-keyframes spin{to{transform:rotate(360deg)}}")})();
import { jsx as a, jsxs as ee, Fragment as Ge } from "react/jsx-runtime";
import { useState as m, useRef as N, useCallback as nt, useLayoutEffect as ke, useEffect as U } from "react";
const $e = ({
  canvas: e,
  backgroundColor: t
}) => {
  const r = e.height, i = e.width, c = Math.round(i / 2), u = e.getContext("2d");
  return u ? (u.clearRect(0, 0, i, r), t !== "transparent" && (u.fillStyle = t, u.fillRect(0, 0, i, r)), { context: u, height: r, width: i, halfWidth: c }) : null;
}, Ce = ({
  context: e,
  color: t,
  rounded: r,
  x: i,
  y: c,
  w: u,
  h: L
}) => {
  e.fillStyle = t, e.beginPath(), e.roundRect ? (e.roundRect(i, c, u, L, r), e.fill()) : e.fillRect(i, c, u, L);
}, it = ({
  barsData: e,
  canvas: t,
  barWidth: r,
  gap: i,
  backgroundColor: c,
  mainBarColor: u,
  secondaryBarColor: L,
  currentAudioTime: v = 0,
  rounded: z,
  duration: d
}) => {
  const f = $e({ canvas: t, backgroundColor: c });
  if (!f)
    return;
  const { context: S, height: g } = f, A = v / d;
  e.forEach((h, I) => {
    const w = I / e.length, s = A > w;
    Ce({
      context: S,
      color: s ? L : u,
      rounded: z,
      x: I * (r + i * r),
      y: g / 2 - h.max,
      h: h.max * 2,
      w: r
    });
  });
};
function ct({
  context: e,
  color: t,
  rounded: r,
  width: i,
  height: c,
  barWidth: u
}) {
  Ce({
    context: e,
    color: t,
    rounded: r,
    x: i / 2 + u / 2,
    y: c / 2 - 1,
    h: 2,
    w: i - (i / 2 + u / 2)
  });
}
const st = ({
  audioData: e,
  unit: t,
  index: r,
  index2: i,
  canvas: c,
  isRecordingInProgress: u,
  isPausedRecording: L,
  picks: v,
  backgroundColor: z,
  barWidth: d,
  mainBarColor: f,
  secondaryBarColor: S,
  rounded: g,
  animateCurrentPick: A,
  fullscreen: h
}) => {
  const I = $e({ canvas: c, backgroundColor: z });
  if (!I)
    return;
  const { context: w, height: s, width: H, halfWidth: b } = I;
  if (e != null && e.length && u) {
    const E = Math.max(...e);
    if (!L) {
      if (i.current >= d) {
        i.current = 0;
        const y = (s - E / 258 * s) / s * 100, W = (-s + E / 258 * s * 2) / s * 100, $ = r.current === d ? {
          startY: y,
          barHeight: W
        } : null;
        r.current >= t ? r.current = d : r.current += d, v.length > (h ? H : b) / d && v.pop(), v.unshift($);
      }
      i.current += 1;
    }
    !h && he(), A && Ce({
      context: w,
      rounded: g,
      color: f,
      x: h ? H : b,
      y: s - E / 258 * s,
      h: -s + E / 258 * s * 2,
      w: d
    });
    let B = (h ? H : b) - i.current;
    v.forEach((y) => {
      y && Ce({
        context: w,
        color: f,
        rounded: g,
        x: B,
        y: y.startY * s / 100 > s / 2 - 1 ? s / 2 - 1 : y.startY * s / 100,
        h: y.barHeight * s / 100 > 2 ? y.barHeight * s / 100 : 2,
        w: d
      }), B -= d;
    });
  } else
    v.length = 0;
  function he() {
    ct({
      context: w,
      color: S,
      rounded: g,
      width: H,
      height: s,
      barWidth: d
    });
  }
}, Je = (e) => {
  const t = Math.floor(e / 3600), r = Math.floor(e % 3600 / 60), i = e % 60, c = Math.floor(
    (i - Math.floor(i)) * 1e3
  );
  return t > 0 ? `${String(t).padStart(2, "0")}:${String(r).padStart(
    2,
    "0"
  )}:${String(Math.floor(i)).padStart(2, "0")}:${String(
    c
  ).charAt(0)}` : r > 0 ? `${String(r).padStart(2, "0")}:${String(
    Math.floor(i)
  ).padStart(2, "0")}:${String(c).charAt(0)}` : `${String(Math.floor(i)).padStart(2, "0")}:${String(
    c
  ).charAt(0)}`;
}, ot = (e) => {
  const t = Math.floor(e / 1e3), r = Math.floor(t / 3600), i = Math.floor(t % 3600 / 60), c = t % 60;
  return r > 0 ? `${String(r).padStart(2, "0")}:${String(i).padStart(
    2,
    "0"
  )}:${String(c).padStart(2, "0")}` : `${String(i).padStart(2, "0")}:${String(c).padStart(2, "0")}`;
};
function Pe(e) {
  if (typeof e == "string") {
    const t = Number(e);
    if (!Number.isNaN(t))
      return `${Math.trunc(t / 2) * 2}px`;
  }
  return e;
}
const at = ({
  bufferData: e,
  height: t,
  width: r,
  barWidth: i,
  gap: c
}) => {
  const u = r / (i + c * i), L = Math.floor(e.length / u), v = t / 2;
  let z = [], d = 0;
  for (let f = 0; f < u; f++) {
    const S = [];
    let g = 0;
    for (let h = 0; h < L && f * L + h < e.length; h++) {
      const I = e[f * L + h];
      I > 0 && (S.push(I), g++);
    }
    const A = S.reduce((h, I) => h + I, 0) / g;
    A > d && (d = A), z.push({ max: A });
  }
  if (v * 0.95 > d * v) {
    const f = v * 0.95 / d;
    z = z.map((S) => ({
      max: S.max > 0.01 ? S.max * f : 1
    }));
  }
  return z;
}, ut = (e) => {
  if (!e)
    return "";
  const t = e.match(/audio\/([^;]+)/);
  return t && t.length >= 2 ? `.${t[1]}` : "";
}, ht = (e) => {
  const t = Math.floor(e / 3600), r = Math.floor(e % 3600 / 60), i = e % 60, c = Math.floor(
    (i - Math.floor(i)) * 1e3
  );
  return t > 0 ? `${String(t).padStart(2, "0")}:${String(r).padStart(
    2,
    "0"
  )}:${String(Math.floor(i)).padStart(2, "0")}}h` : r > 0 ? `${String(r).padStart(2, "0")}:${String(
    Math.floor(i)
  ).padStart(2, "0")}m` : `${String(Math.floor(i)).padStart(2, "0")}:${String(
    c
  ).charAt(0)}${String(c).charAt(1)}s`;
}, lt = (e) => {
  onmessage = (t) => {
    postMessage(e(t.data));
  };
};
function mt({
  fn: e,
  initialValue: t,
  onMessageReceived: r
}) {
  const [i, c] = m(t);
  return {
    result: i,
    setResult: c,
    run: (L) => {
      const v = new Worker(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        URL.createObjectURL(new Blob([`(${lt})(${e})`]))
      );
      v.onmessage = (z) => {
        z.data && (c(z.data), r && r(), v.terminate());
      }, v.onerror = (z) => {
        console.error(z.message), v.terminate();
      }, v.postMessage(L);
    }
  };
}
const vt = (e, t = 250) => {
  const r = N();
  return nt(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...i) => {
      const c = () => {
        clearTimeout(r.current), e(...i);
      };
      clearTimeout(r.current), r.current = setTimeout(c, t);
    },
    [e, t]
  );
};
function dt(e) {
  const t = N(e);
  return ke(() => {
    t.current = e;
  }, [e]), t;
}
const ft = ({
  color: e = "#000000",
  stroke: t = 2,
  className: r
}) => /* @__PURE__ */ a(
  "svg",
  {
    viewBox: "0 0 23 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r,
    children: /* @__PURE__ */ a(
      "path",
      {
        d: "M1.1 16.72c0 3 .96 5.8 3.61 7.95a9.96 9.96 0 0 0 6.5 2.17m0 0v4.34h4.34-8.67m4.34-4.34c2.35 0 4.42-.48 6.5-2.17a9.87 9.87 0 0 0 3.61-7.95M11.22 1.82c-1.45 0-2.5.37-3.3.93a5.6 5.6 0 0 0-1.84 2.4c-.9 2.06-1.1 4.77-1.1 7.24 0 2.46.2 5.17 1.1 7.24a5.6 5.6 0 0 0 1.84 2.4c.8.55 1.85.92 3.3.92 1.44 0 2.5-.37 3.29-.93a5.6 5.6 0 0 0 1.84-2.4c.9-2.06 1.1-4.77 1.1-7.23 0-2.47-.2-5.18-1.1-7.24a5.6 5.6 0 0 0-1.84-2.4 5.52 5.52 0 0 0-3.3-.93Z",
        stroke: e,
        strokeWidth: t,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Re = ({
  color: e = "#FFFFFF",
  reflect: t
}) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.92 17.54 48.27 14.92",
    className: `voice-visualizer__canvas-audio-wave-icon ${t ? "voice-visualizer__canvas-audio-wave-icon2" : ""}`,
    children: /* @__PURE__ */ a(
      "path",
      {
        d: "M.92 24.63h.21v.75H.92zm.42-1.39h.21v3.52h-.21zm.43.68h.21v2.17h-.21zM2.2 22h.21v6.01H2.2zm.43-1.27h.21v8.55h-.21zm.43 2.07h.21v4.4h-.21zm.43 1.22h.21v1.97h-.21zm.43.47h.21v1.03h-.21zm.43-1.66h.21v4.35h-.21zm.43-1.74h.21v7.82h-.21zm.43 1.94h.21v3.94h-.21zm.43 1.07h.21v1.81h-.21zm.42-.94h.21v3.68h-.21zm.43.91h.21v1.86h-.21zm.43-.23h.21v2.33h-.21zm.43.46h.21v1.4h-.21zm.43-.7h.21v2.8h-.21zm.43-1.6h.21v6.01h-.21zm.43-2.23h.21v10.46h-.21zm.43-1.4h.21v13.26h-.21zm.43.62h.21v12.02H9.5zm.43 1.64h.21v8.75h-.21zm.43 1.37h.21v6.01h-.21zm.43-1.87H11v9.74h-.21zm.42 1.32h.21v7.1h-.21zm.43-2.64h.21v12.38h-.21zm.43 1.61h.21v9.17h-.21zM12.5 22h.21v6.01h-.21zm.43 1.32h.21v3.37h-.21zm.43-2.51h.21v8.39h-.21zm.43.59H14v7.2h-.21zm.43 1.79h.21v3.62h-.21zm.43.41h.21v2.8h-.21zm.43.57h.21v1.66h-.21zm.43-1.11h.21v3.88h-.21zm.42-2.98h.21v9.84h-.21zm.43 1.06h.21v7.72h-.21zm.43 3.19H17v1.35h-.21zm.86-2.33h.21v6.01h-.21zm-.43 1.4h.21v3.21h-.21zm1.29.15h.21v2.9h-.21zm.43.68h.21v1.55h-.21zm-.86-.76h.21v3.05h-.21zm1.29-.05h.21v3.16h-.21zm.43-.64h.21v4.45h-.21zm.43.38h.21v3.68h-.21zm.42-.49h.21v4.66h-.21zm.43 1.32h.21v2.02h-.21zm.43.37h.21v1.29h-.21zm.43.31h.21v.67h-.21zm.43-.39h.21v1.45h-.21zm.43-1.35h.21v4.14h-.21zm.86.73h.21v2.69h-.21zm-.43.44h.21v1.81h-.21zm1.29-3.45h.21v8.7h-.21zm.43 1.71h.21v5.28h-.21zm-.86-2.3h.21v9.89h-.21zm1.29 3.36h.21v3.16h-.21zM25.8 22h.21v6.01h-.21zm.43 1.42h.21v3.16h-.21zm.43.88h.21v1.4h-.21zm.43-.93h.21v3.26h-.21zm.43-1.37h.21v6.01h-.21zm.43-.93h.21v7.87h-.21zm.43-.76h.21v9.38h-.21zm.43 1.69h.21v6.01h-.21zm.86 1.92h.21v2.17h-.21zm-.43-.6h.21v3.37h-.21zm1.28.05h.21v3.26h-.21zm.43.67h.21v1.91h-.21zm-.85-.51h.21v2.95h-.21zm1.28-.13h.21v3.21h-.21zm.43-1.4h.21v6.01h-.21zm.43-.99h.21v7.98h-.21zm.43 1.77h.21v4.45h-.21zm.43-1.22h.21v6.89h-.21zm.43 1.6h.21v3.68h-.21zm.43-.28h.21v4.25h-.21zm.43-.6h.21v5.44h-.21zm.43-.28h.21v6.01h-.21zm.85 2.02h.21v1.97h-.21zm-.43-.57h.21v3.11h-.21zm1.29.93h.21v1.24h-.21zm.43-.65h.21v2.54h-.21zm-.86-.28h.21v3.11h-.21zm1.29.83h.21v1.45h-.21zm.43-.99h.21v3.42h-.21zm.43-.1h.21v3.62h-.21zm.43-.7h.21v5.02h-.21zm.43.8h.21v3.42h-.21zm.43-1.29h.21v6.01h-.21zm.42-1.71h.21v9.43h-.21zm.43 2.38h.21v4.66h-.21zm.43.65h.21v3.37h-.21zm.86.08h.21v3.21h-.21zm-.43.54h.21v2.12h-.21zm1.29-.05h.21v2.23h-.21zm.43.28h.21v1.66h-.21zm-.86.16h.21v1.35h-.21zm1.29.21h.21v.93h-.21zm.43-6.04h.21v13h-.21zm.43.8h.21v11.4h-.21zm.43-1.76h.21v14.92h-.21zm.42 1.09h.21v12.74h-.21zm.43 1.17h.21v10.41h-.21zm.43 1.32h.21v7.77h-.21zm.43 1.6h.21v4.56h-.21zm.43 1.17h.21v2.23h-.21zm.86-.08h.21v2.38h-.21zm-.43-.34h.21v3.05h-.21zm1.29-.1h.21v3.26h-.21zm.43.93h.21v1.4h-.21zm-.86-.02h.21v1.45h-.21z",
        fill: e
      }
    )
  }
), Be = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMzMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTEuMSAxNi43MmMwIDMgLjk2IDUuOCAzLjYxIDcuOTVhOS45NiA5Ljk2IDAgMCAwIDYuNSAyLjE3bTAgMHY0LjM0aDQuMzQtOC42N200LjM0LTQuMzRjMi4zNSAwIDQuNDItLjQ4IDYuNS0yLjE3YTkuODcgOS44NyAwIDAgMCAzLjYxLTcuOTVNMTEuMjIgMS44MmMtMS40NSAwLTIuNS4zNy0zLjMuOTNhNS42IDUuNiAwIDAgMC0xLjg0IDIuNGMtLjkgMi4wNi0xLjEgNC43Ny0xLjEgNy4yNCAwIDIuNDYuMiA1LjE3IDEuMSA3LjI0YTUuNiA1LjYgMCAwIDAgMS44NCAyLjRjLjguNTUgMS44NS45MiAzLjMuOTIgMS40NCAwIDIuNS0uMzcgMy4yOS0uOTNhNS42IDUuNiAwIDAgMCAxLjg0LTIuNGMuOS0yLjA2IDEuMS00Ljc3IDEuMS03LjIzIDAtMi40Ny0uMi01LjE4LTEuMS03LjI0YTUuNiA1LjYgMCAwIDAtMS44NC0yLjQgNS41MiA1LjUyIDAgMCAwLTMuMy0uOTNaIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", zt = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTE4Ljc1IDYuMTZjNC4zMSAyLjYgNi40NiAzLjkgNi40NiA1Ljg0IDAgMS45NS0yLjE1IDMuMjQtNi40NiA1Ljg0bC00Ljg0IDIuOTJjLTQuMzEgMi42LTYuNDYgMy44OS04LjA4IDIuOTItMS42Mi0uOTgtMS42Mi0zLjU3LTEuNjItOC43NlY5LjA4YzAtNS4xOSAwLTcuNzggMS42Mi04Ljc2IDEuNjItLjk3IDMuNzcuMzMgOC4wOCAyLjkybDQuODQgMi45MloiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg==", We = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTE0IDMuNWEzLjUgMy41IDAgMSAxIDcgMHYyMmEzLjUgMy41IDAgMSAxLTcgMHYtMjJaIiBmaWxsPSIjZmZmIi8+CiAgPHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjkiIHJ4PSIzLjUiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg==", gt = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHJlY3QgeD0iLjIxIiB3aWR0aD0iMjYiIGhlaWdodD0iMjUiIHJ4PSI1IiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPgo=", It = ({
  controls: {
    audioRef: e,
    audioData: t,
    isRecordingInProgress: r,
    recordedBlob: i,
    duration: c,
    currentAudioTime: u,
    audioSrc: L,
    bufferFromRecordedBlob: v,
    togglePauseResume: z,
    startRecording: d,
    stopRecording: f,
    saveAudioFile: S,
    isAvailableRecordedAudio: g,
    isPausedRecordedAudio: A,
    isPausedRecording: h,
    isProcessingStartRecording: I,
    isProcessingRecordedAudio: w,
    isCleared: s,
    formattedDuration: H,
    formattedRecordingTime: b,
    formattedRecordedAudioCurrentTime: he,
    clearCanvas: E,
    setCurrentAudioTime: B,
    isProcessingOnResize: y,
    _setIsProcessingOnResize: W,
    _setIsProcessingAudioOnComplete: $
  },
  width: te = "100%",
  height: re = 200,
  speed: we = 3,
  backgroundColor: F = "transparent",
  mainBarColor: D = "#FFFFFF",
  secondaryBarColor: k = "#5e5e5e",
  barWidth: le = 2,
  gap: J = 1,
  rounded: O = 5,
  isControlPanelShown: Q = !0,
  isDownloadAudioButtonShown: ne = !1,
  animateCurrentPick: me = !0,
  fullscreen: ve = !1,
  onlyRecording: V = !1,
  isDefaultUIShown: Le = !0,
  defaultMicrophoneIconColor: Se = D,
  defaultAudioWaveIconColor: ie = D,
  mainContainerClassName: ce,
  canvasContainerClassName: Ne,
  isProgressIndicatorShown: se = !V,
  progressIndicatorClassName: M,
  isProgressIndicatorTimeShown: Z = !0,
  progressIndicatorTimeClassName: q,
  isProgressIndicatorOnHoverShown: oe = !V,
  progressIndicatorOnHoverClassName: X,
  isProgressIndicatorTimeOnHoverShown: C = !0,
  progressIndicatorTimeOnHoverClassName: x,
  isAudioProcessingTextShown: o = !0,
  audioProcessingTextClassName: Ae,
  controlButtonsClassName: je
}) => {
  const [de, be] = m(0), [T, ye] = m(0), [ae, xe] = m(0), [fe, ze] = m(0), [Y, ge] = m(!1), [De, Te] = m(window.innerWidth), [G, _e] = m(!1), Ee = De < 768, P = Math.trunc(we), ue = Math.trunc(J), n = Math.trunc(
    Ee && ue > 0 ? le + 1 : le
  ), p = n + ue * n, l = N(null), _ = N([]), K = N(P), Qe = N(n), Ve = N(n), Me = N(null), qe = dt(De), {
    result: pe,
    setResult: Xe,
    run: Ke
  } = mt({
    fn: at,
    initialValue: [],
    onMessageReceived: tt
  }), et = vt(He);
  U(() => {
    He();
    const j = () => {
      qe.current !== window.innerWidth && (g ? (Te(window.innerWidth), W(!0), _e(!0), et()) : (Te(window.innerWidth), He()));
    };
    return window.addEventListener("resize", j), () => {
      window.removeEventListener("resize", j);
    };
  }, [te, g]), ke(() => {
    l.current && ((K.current >= P || !t.length) && (K.current = t.length ? 0 : P, st({
      audioData: t,
      unit: p,
      index: Qe,
      index2: Ve,
      canvas: l.current,
      picks: _.current,
      isRecordingInProgress: r,
      isPausedRecording: h,
      backgroundColor: F,
      mainBarColor: D,
      secondaryBarColor: k,
      barWidth: n,
      rounded: O,
      animateCurrentPick: me,
      fullscreen: ve
    })), K.current += 1);
  }, [
    l.current,
    t,
    n,
    F,
    D,
    k,
    O,
    ve,
    Le,
    fe
  ]), U(() => {
    var j, R;
    if (g)
      return Y ? (j = l.current) == null || j.addEventListener("mouseleave", Ze) : (R = l.current) == null || R.addEventListener("mouseenter", Oe), () => {
        var Ie, Ye;
        Y ? (Ie = l.current) == null || Ie.removeEventListener("mouseleave", Ze) : (Ye = l.current) == null || Ye.removeEventListener("mouseenter", Oe);
      };
  }, [Y, g]), U(() => {
    var R;
    if (!v || !l.current || r || G)
      return;
    if (V) {
      E();
      return;
    }
    _.current = [];
    const j = v.getChannelData(0);
    return Ke({
      bufferData: j,
      height: ae,
      width: fe,
      barWidth: n,
      gap: ue
    }), (R = l.current) == null || R.addEventListener("mousemove", Ue), () => {
      var Ie;
      (Ie = l.current) == null || Ie.removeEventListener(
        "mousemove",
        Ue
      );
    };
  }, [
    v,
    T,
    ae,
    J,
    le,
    G
  ]), U(() => {
    if (!(V || !(pe != null && pe.length) || !l.current || w)) {
      if (s) {
        Xe([]);
        return;
      }
      it({
        barsData: pe,
        canvas: l.current,
        barWidth: n,
        gap: ue,
        backgroundColor: F,
        mainBarColor: D,
        secondaryBarColor: k,
        currentAudioTime: u,
        rounded: O,
        duration: c
      });
    }
  }, [
    pe,
    u,
    s,
    O,
    F,
    D,
    k
  ]), U(() => {
    w && l.current && $e({
      canvas: l.current,
      backgroundColor: F
    });
  }, [w]);
  function He() {
    if (!Me.current || !l.current)
      return;
    K.current = P;
    const j = Math.trunc(
      Me.current.clientHeight * window.devicePixelRatio / 2
    ) * 2;
    ye(Me.current.clientWidth), xe(j), ze(
      Math.round(
        Me.current.clientWidth * window.devicePixelRatio
      )
    ), _e(!1);
  }
  function tt() {
    W(!1), $(!1), e != null && e.current && !y && (e.current.src = L);
  }
  const Oe = () => {
    ge(!0);
  }, Ze = () => {
    ge(!1);
  }, Ue = (j) => {
    be(j.offsetX);
  }, rt = (j) => {
    if (e != null && e.current && l.current) {
      const R = c / T * (j.clientX - l.current.getBoundingClientRect().left);
      e.current.currentTime = R, B(R);
    }
  }, Fe = u / c * T;
  return /* @__PURE__ */ ee("div", { className: `voice-visualizer ${ce ?? ""}`, children: [
    /* @__PURE__ */ ee(
      "div",
      {
        className: `voice-visualizer__canvas-container ${Ne ?? ""}`,
        ref: Me,
        style: { width: Pe(te) },
        children: [
          /* @__PURE__ */ a(
            "canvas",
            {
              ref: l,
              width: fe,
              height: ae,
              onClick: rt,
              style: {
                height: Pe(re),
                width: T
              },
              children: "Your browser does not support HTML5 Canvas."
            }
          ),
          Le && s && /* @__PURE__ */ ee(Ge, { children: [
            /* @__PURE__ */ a(Re, { color: ie }),
            /* @__PURE__ */ a(Re, { color: ie, reflect: !0 }),
            /* @__PURE__ */ a(
              "button",
              {
                onClick: d,
                className: "voice-visualizer__canvas-microphone-btn",
                children: /* @__PURE__ */ a(
                  ft,
                  {
                    color: Se,
                    stroke: 0.5,
                    className: "voice-visualizer__canvas-microphone-icon"
                  }
                )
              }
            )
          ] }),
          o && w && /* @__PURE__ */ a(
            "p",
            {
              className: `voice-visualizer__canvas-audio-processing ${Ae ?? ""}`,
              style: { color: D },
              children: "Processing Audio..."
            }
          ),
          Y && g && !w && !Ee && oe && /* @__PURE__ */ a(
            "div",
            {
              className: `voice-visualizer__progress-indicator-hovered ${X ?? ""}`,
              style: {
                left: de
              },
              children: C && /* @__PURE__ */ a(
                "p",
                {
                  className: `voice-visualizer__progress-indicator-hovered-time 
                    ${T - de < 70 ? "voice-visualizer__progress-indicator-hovered-time-left" : ""} 
                    ${x ?? ""}`,
                  children: Je(
                    c / T * de
                  )
                }
              )
            }
          ),
          se && g && !w && c ? /* @__PURE__ */ a(
            "div",
            {
              className: `voice-visualizer__progress-indicator ${M ?? ""}`,
              style: {
                left: Fe < T - 1 ? Fe : T - 1
              },
              children: Z && /* @__PURE__ */ a(
                "p",
                {
                  className: `voice-visualizer__progress-indicator-time ${T - u * T / c < 70 ? "voice-visualizer__progress-indicator-time-left" : ""} ${q ?? ""}`,
                  children: he
                }
              )
            }
          ) : null
        ]
      }
    ),
    Q && /* @__PURE__ */ ee(Ge, { children: [
      /* @__PURE__ */ ee("div", { className: "voice-visualizer__audio-info-container", children: [
        r && /* @__PURE__ */ a("p", { className: "voice-visualizer__audio-info-time", children: b }),
        c && !w ? /* @__PURE__ */ a("p", { children: H }) : null
      ] }),
      /* @__PURE__ */ ee("div", { className: "voice-visualizer__buttons-container", children: [
        r && /* @__PURE__ */ a("div", { className: "voice-visualizer__btn-container", children: /* @__PURE__ */ a(
          "button",
          {
            className: `voice-visualizer__btn-left ${h ? "voice-visualizer__btn-left-microphone" : ""}`,
            onClick: z,
            children: /* @__PURE__ */ a(
              "img",
              {
                src: h ? Be : We,
                alt: h ? "Play" : "Pause"
              }
            )
          }
        ) }),
        !s && /* @__PURE__ */ a(
          "button",
          {
            className: `voice-visualizer__btn-left ${r || I ? "voice-visualizer__visually-hidden" : ""}`,
            onClick: z,
            disabled: w,
            children: /* @__PURE__ */ a(
              "img",
              {
                src: A ? zt : We,
                alt: A ? "Play" : "Pause"
              }
            )
          }
        ),
        s && /* @__PURE__ */ ee(
          "button",
          {
            className: `voice-visualizer__btn-center relative ${I ? "voice-visualizer__btn-center--border-transparent" : ""}`,
            onClick: d,
            disabled: I,
            children: [
              I && /* @__PURE__ */ a("div", { className: "spinner__wrapper", children: /* @__PURE__ */ a("div", { className: "spinner" }) }),
              /* @__PURE__ */ a("img", { src: Be, alt: "Microphone" })
            ]
          }
        ),
        /* @__PURE__ */ a(
          "button",
          {
            className: `voice-visualizer__btn-center voice-visualizer__btn-center-pause ${r ? "" : "voice-visualizer__visually-hidden"}`,
            onClick: f,
            children: /* @__PURE__ */ a("img", { src: gt, alt: "Stop" })
          }
        ),
        !s && /* @__PURE__ */ a(
          "button",
          {
            onClick: E,
            className: `voice-visualizer__btn ${je ?? ""}`,
            disabled: w,
            children: "Clear"
          }
        ),
        ne && i && /* @__PURE__ */ a(
          "button",
          {
            onClick: S,
            className: `voice-visualizer__btn ${je ?? ""}`,
            disabled: w,
            children: "Download Audio"
          }
        )
      ] })
    ] })
  ] });
};
function wt({
  onStartRecording: e,
  onStopRecording: t,
  onPausedRecording: r,
  onResumedRecording: i,
  onClearCanvas: c,
  onEndAudioPlayback: u,
  onStartAudioPlayback: L,
  onPausedAudioPlayback: v,
  onResumedAudioPlayback: z,
  onErrorPlayingAudio: d
} = {}) {
  const [f, S] = m(!1), [g, A] = m(!1), [h, I] = m(null), [w, s] = m(new Uint8Array(0)), [H, b] = m(!1), [he, E] = m(null), [B, y] = m(null), [W, $] = m(0), [te, re] = m(0), [we, F] = m(0), [D, k] = m(""), [le, J] = m(!0), [O, Q] = m(0), [ne, me] = m(!0), [ve, V] = m(!1), [Le, Se] = m(!1), [ie, ce] = m(null), [Ne, se] = m(!1), M = N(null), Z = N(null), q = N(null), oe = N(null), X = N(null), C = N(null), x = N(null), o = N(null), Ae = !!(B && !H), je = ht(we), de = ot(W), be = Je(O), T = ve || H;
  U(() => {
    if (!f || g)
      return;
    const p = setInterval(() => {
      const l = performance.now();
      $((_) => _ + (l - te)), re(l);
    }, 1e3);
    return () => clearInterval(p);
  }, [te, g, f]), U(() => {
    if (ie) {
      G();
      return;
    }
  }, [ie]), U(() => () => {
    G();
  }, []), U(() => (ne || window.addEventListener("beforeunload", ye), () => {
    window.removeEventListener("beforeunload", ye);
  }), [ne]);
  const ye = (n) => {
    n.preventDefault(), n.returnValue = "";
  }, ae = async (n) => {
    if (n)
      try {
        if (n.size === 0)
          throw new Error("Error: The audio blob is empty");
        const p = URL.createObjectURL(n);
        k(p);
        const l = await n.arrayBuffer(), K = await new AudioContext().decodeAudioData(l);
        y(K), F(K.duration - 0.06), ce(null);
      } catch (p) {
        console.error("Error processing the audio blob:", p), ce(
          p instanceof Error ? p : new Error("Error processing the audio blob")
        );
      }
  }, xe = (n) => {
    n instanceof Blob && (G(), Se(!0), me(!1), b(!0), S(!1), $(0), A(!1), o.current = new Audio(), E(n), ae(n));
  }, fe = () => {
    se(!0), navigator.mediaDevices.getUserMedia({ audio: !0 }).then((n) => {
      me(!1), se(!1), S(!0), re(performance.now()), I(n), Z.current = new window.AudioContext(), q.current = Z.current.createAnalyser(), oe.current = new Uint8Array(
        q.current.frequencyBinCount
      ), X.current = Z.current.createMediaStreamSource(n), X.current.connect(q.current), M.current = new MediaRecorder(n), M.current.addEventListener(
        "dataavailable",
        Y
      ), M.current.start(), e && e(), ze();
    }).catch((n) => {
      se(!1), ce(
        n instanceof Error ? n : new Error("Error starting audio recording")
      );
    });
  }, ze = () => {
    q.current.getByteTimeDomainData(oe.current), s(new Uint8Array(oe.current)), C.current = requestAnimationFrame(ze);
  }, Y = (n) => {
    M.current && (M.current = null, o.current = new Audio(), E(n.data), ae(n.data));
  }, ge = () => {
    o.current && (Q(o.current.currentTime), x.current = requestAnimationFrame(ge));
  }, De = () => {
    f || Ne || (ne || G(), fe());
  }, Te = () => {
    f && (S(!1), M.current && (M.current.stop(), M.current.removeEventListener(
      "dataavailable",
      Y
    )), h == null || h.getTracks().forEach((n) => n.stop()), C.current && cancelAnimationFrame(C.current), X.current && X.current.disconnect(), Z.current && Z.current.state !== "closed" && Z.current.close(), b(!0), $(0), A(!1), t && t());
  }, G = () => {
    C.current && (cancelAnimationFrame(C.current), C.current = null), x.current && (cancelAnimationFrame(x.current), x.current = null), M.current && (M.current.removeEventListener(
      "dataavailable",
      Y
    ), M.current.stop(), M.current = null), h == null || h.getTracks().forEach((n) => n.stop()), o != null && o.current && (o.current.removeEventListener("ended", P), o.current.pause(), o.current.src = "", o.current = null), Z.current = null, q.current = null, oe.current = null, X.current = null, I(null), se(!1), S(!1), Se(!1), b(!1), E(null), y(null), $(0), re(0), F(0), k(""), Q(0), J(!0), A(!1), V(!1), s(new Uint8Array(0)), ce(null), me(!0), c && c();
  }, _e = () => {
    if (o.current && o.current.paused) {
      const n = o.current.play();
      n !== void 0 && n.catch((p) => {
        console.error(p), d && d(
          p instanceof Error ? p : new Error("Error playing audio")
        );
      });
    }
  }, Ee = () => {
    var n, p, l;
    if (f) {
      A((_) => !_), ((n = M.current) == null ? void 0 : n.state) === "recording" ? ((p = M.current) == null || p.pause(), $((_) => _ + (performance.now() - te)), C.current && cancelAnimationFrame(C.current), r && r()) : (C.current = requestAnimationFrame(ze), (l = M.current) == null || l.resume(), re(performance.now()), i && i());
      return;
    }
    if (o.current && Ae)
      if (o.current.paused)
        requestAnimationFrame(ge), _e(), o.current.addEventListener("ended", P), J(!1), L && O === 0 && L(), z && O !== 0 && z();
      else {
        x.current && cancelAnimationFrame(x.current), o.current.removeEventListener("ended", P), o.current.pause(), J(!0);
        const _ = o.current.currentTime;
        Q(_), o.current.currentTime = _, v && v();
      }
  }, P = () => {
    x.current && cancelAnimationFrame(x.current), J(!0), o != null && o.current && (o.current.currentTime = 0, Q(0), u && u());
  }, ue = () => {
    var p;
    if (!D)
      return;
    const n = document.createElement("a");
    n.href = D, n.download = `recorded_audio${ut(
      (p = M.current) == null ? void 0 : p.mimeType
    )}`, document.body.appendChild(n), n.click(), document.body.removeChild(n), URL.revokeObjectURL(D);
  };
  return {
    audioRef: o,
    isRecordingInProgress: f,
    isPausedRecording: g,
    audioData: w,
    recordingTime: W,
    isProcessingRecordedAudio: T,
    recordedBlob: he,
    mediaRecorder: M.current,
    duration: we,
    currentAudioTime: O,
    audioSrc: D,
    isPausedRecordedAudio: le,
    bufferFromRecordedBlob: B,
    isCleared: ne,
    isAvailableRecordedAudio: Ae,
    formattedDuration: je,
    formattedRecordingTime: de,
    formattedRecordedAudioCurrentTime: be,
    startRecording: De,
    togglePauseResume: Ee,
    stopRecording: Te,
    saveAudioFile: ue,
    clearCanvas: G,
    setCurrentAudioTime: Q,
    error: ie,
    isProcessingOnResize: ve,
    isProcessingStartRecording: Ne,
    isPreloadedBlob: Le,
    setPreloadedAudioBlob: xe,
    _setIsProcessingAudioOnComplete: b,
    _setIsProcessingOnResize: V
  };
}
export {
  It as VoiceVisualizer,
  wt as useVoiceVisualizer
};
